import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blogging, hats, stuff",
  "description": "",
  "published": "2012-01-19T00:00:00.000Z",
  "redirect_from": ["/blog/blogging-hats-stuff/swizec/3483"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/5AVGVH1VUM5DXZFON5TXZN4EWVHI1EK5D5AMTZIUON1SQBHW1.jpg",
        "alt": "Presenting",
        "title": "Presenting"
      }}></img></p>
    <p>{`Yesterday I gave a talk at `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.056184,14.503798&spn=0.005,0.005&q=46.056184,14.503798%20(Kiberpipa)&t=h",
        "title": "Kiberpipa"
      }}>{`Kiberpipa`}</a>{` on the awesome `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/search?q=%23wwwh"
      }}>{`#wwwh`}</a>{` weekly event. The talk was about this blog and how after `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/why-programmers-work-at-night/swizec/3198",
        "title": "Why programmers work at night"
      }}>{`that one insanely popular post`}</a>{`everyone suddenly decided I know what I'm doing and should tell others how its done.`}</p>
    <p><em parentName="p">{`Video at bottom`}</em></p>
    <p>{`It's funny how difficult coming up with a talk is when somebody tweets you `}<em parentName="p">{`Hey, you should totally come give a talk about blogging.`}</em>{` The problem with these kinds of talk is that you don't really know what you'll be trying to say. Every time you're up there on stage you should have a message - something to convince the audience of.`}</p>
    <p>{`Just giving a general talk `}<em parentName="p">{`sucks`}</em>{` for that. It invariably turns into something a bit like this post - a rambling conglomerate of sentences that sort of go together. Always reminds me of that one line in a movie: `}<em parentName="p">{`You talk a lot, but you don't say much.`}</em></p>
    <p>{`I guess the overall message of my talk was this:`}</p>
    <p><em parentName="p">{`Patience! It takes a lot of patience and sticking-to-it-ness, don't do if it isn't inherently fun for you.`}</em></p>
    <p>{`Despite all of that I think the talk was a smashing success. Sure I forgot to even mention hats - was supposed to mention changing the blog's name from Cthulhu and Other Crazies to A Geek With a Hat ... oops? In general the talk ended up a bit rambley, even finished with "Wait, there was something else I wanted to say ... oh well. Questions?"`}</p>
    <p>{`That's not a very strong ending. The originally planned ending was: `}<em parentName="p">{`But hey, at least I'm no longer The Author on hackernews, but Swizec`}</em></p>
    <p>{`All in all, rhetoric sucked, body language was attrocious, hands found their way into pockets several times, but people laughed a few times, asked a bunch of questions and I think everyone had fun. This one girl even asked for actual advice and I thank her for thinking I know enough to give advice about this stuff.`}</p>
    <p>{`The slides for `}<a parentName="p" {...{
        "href": "http://speakerdeck.com/u/swizec/p/blogging-hats-stuff"
      }}>{`Blogging, hats, stuff`}</a>{` are over at Speakerdeck whose embeds don't work with Wordpress ... there is also a video.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://brian.kingsonline.net/talk/2011/10/web-hour-zemanta-mozilla-success/"
        }}>{`Web Hour + Zemanta + Mozilla = Success`}</a>{` (brian.kingsonline.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//money.cnn.com/2012/01/13/technology/sal_khan_best_advice.fortune/index.htm&a=71417522&rid=d059e249-7cef-4f9a-9287-844dce83e91a&e=23df49d4c5da66b3b023eda0ebdb9d56"
        }}>{`Sal Khan: The best advice I ever got`}</a>{` (money.cnn.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://markos.gaivo.net/blog/?p=807"
        }}>{`6th anniversary of wwwh`}</a>{` (markos.gaivo.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://doingthewritething.wordpress.com/2012/01/17/odd-like-us/"
        }}>{`Odd Like Us`}</a>{` (doingthewritething.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.tablix.org/~avian/blog/archives/2012/01/video_of_my_433_mhz_receiver_talk/"
        }}>{`Video of my 433 MHz receiver talk`}</a>{` (tablix.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d059e249-7cef-4f9a-9287-844dce83e91a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      